module.exports = __webpack_public_path__ + "img/Calender.5492612d.svg";